import { render, staticRenderFns } from "./TimetableSplitViewEventList.vue?vue&type=template&id=6702e0f1&"
import script from "./TimetableSplitViewEventList.vue?vue&type=script&lang=js&"
export * from "./TimetableSplitViewEventList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports